import { Tooltip, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const BackButton = ({ msg = 'Back', onClick }) => {
  return (
    <Tooltip title={msg}>
      <IconButton onClick={onClick} color="primary"
        size="medium"
        sx={{
          marginRight: 2,
          backgroundColor: '#e3f2fd',
          '&:hover': { backgroundColor: '#bbdefb' },
        }}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
};


// import { renderToolTip } from '../../../utils/helper';
// import { Button } from 'react-bootstrap';

// export const BackButton = ({ msg = 'Back', onClick }) => {
//   return (
//     <span>
//       {renderToolTip(
//         msg,
//         <Button onClick={onClick} style={{ cursor: 'pointer' }}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="16"
//             height="16"
//             fill="currentColor"
//             className="bi bi-arrow-left"
//             viewBox="0 0 16 16"
//           >
//             <path
//               fillRule="evenodd"
//               d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
//             />
//           </svg>
//         </Button>
//       )}
//     </span>
//   );
// };
